import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function VerifyOTP() {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [otp, setOtp] = useState(['', '', '', '']);
    const { isAuthenticated } = useAuth();


    const handleOtpChange = (value, index) => {
        if (!/^\d*$/.test(value)) return; // Allow only numeric values
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Automatically focus next input if a digit is entered
        if (value && index < 3) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleVarifyEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const sanitizedEmail = DOMPurify.sanitize(email);
            const sanitizedOTP = DOMPurify.sanitize(otp.join(''));


            const response = await fetch(`${baseURL}/verify-otp`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: sanitizedEmail,
                    otp_code: sanitizedOTP
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    toast.success(result.message, {
                        onClose: () => navigate('/edit_detail', { state: { email: sanitizedEmail } }), // Redirect after the toast closes
                    });
                }
                else if (result.status_code === 400) {
                    toast.error(result.message);
                }


            }
            else {
                toast.error(result.message || 'Registration Failed');
            }
        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }

    }
    if (isAuthenticated) {
        return <Navigate to="/" />;
    }


    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                theme="dark"
            />


            <section className='user-form-part my-4'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-xl-8 col-md-12 main-user-box position-relative'>
                            <div className='row justify-content-center align-items-center row-flex'>
                                <div className='col-md-4 px-0'>
                                    <div className='user-box'>
                                        <img src="assets/images/elements/otp_bg.png" className='vidhya_icon' alt="Section-Image" />
                                    </div>
                                </div>
                                <div className='col-md-8 text-center px-0'>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-8 col-xl-5 position-absolute'>
                            <div className='otp-box'>
                                <form onSubmit={handleVarifyEmail} className="user-form">
                                    <div className="user-form-title">
                                        <h2>OTP Verification</h2>
                                    </div>
                                    
                                    <div className="form-group d-flex justify-content-center">
                                    <span>OTP has been sent to </span>
                                        <input type="email" className="form-control user-email vefify-email-box" id="email" name="email" value={email} placeholder='Enter Email' required readOnly />
                                        <a href='/create_account'>Edit</a>
                                    </div>
                                    <div className="form-group otp-boxes">
                                        {otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                id={`otp-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={digit}
                                                onChange={(e) => handleOtpChange(e.target.value, index)}
                                                onFocus={(e) => e.target.select()}
                                                required
                                            />
                                        ))}
                                    </div>
                                    {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                    <div className="col-md-12 text-center">
                                        <button
                                            type="submit"
                                            className='btn-6 view-all-btnn mt-3 text-capitalize'
                                            disabled={isLoading}
                                        >
                                            {isLoading ? <div class="spinner-border" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div> : 'Verify Now'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="user-form-part my-4 d-none">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-8 col-xl-5">
                            <div className="user-form-card">

                                <div className="user-form-group">
                                    <form onSubmit={handleVarifyEmail} className="user-form">
                                        <div className="user-form-title">
                                            <h2>Create Your Account</h2>
                                            <p>OTP Verification</p>
                                        </div>
                                       
                                        <div className="form-group d-flex">
                                        <span>OTP has been sent to </span>
                                            <input type="email" className="form-control user-email vefify-email-box" id="email" name="email" value={email} placeholder='Enter Email' required readOnly />
                                            <a href='/create_account'>Edit</a>
                                        </div>
                                        <div className="form-group otp-boxes">
                                            {otp.map((digit, index) => (
                                                <input
                                                    key={index}
                                                    id={`otp-${index}`}
                                                    type="text"
                                                    maxLength="1"
                                                    value={digit}
                                                    onChange={(e) => handleOtpChange(e.target.value, index)}
                                                    onFocus={(e) => e.target.select()}
                                                    required
                                                />
                                            ))}
                                        </div>
                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : 'Verify Now'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
